import FaceActivateWarning from './FaceActivateWarning';

export default FaceActivateWarning;
